import { IncomingDashboardAchievements } from '../../../types/Dashboard/Achievements/DashAchievementTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../utils/apiUtils'
import { dashboardApiConfig, AllowedHttpMethods } from '../apiList'

const getAllAchievements = async (): Promise<IncomingDashboardAchievements> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: dashboardApiConfig.getAllAchievements,
    method: AllowedHttpMethods.get,
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const achievementsApi = {
  getAllAchievements,
}

export default achievementsApi
